<script setup>
import {computed, watch, ref, inject} from "vue";
import HeadlineComponent from "./Headline.vue";
import GuidanceComponent from "../../layouts/components/Notice.vue";
import PageTransition from "./PageTransition.vue";

const props = defineProps({
    title: String,
    items: Array,
    inputValues: Object,
    nextIndex: Number,
    previousIndex: Number,
    message: String,
    direction: String,
    image: {
        type: String,
        required: false,
        default: null
    },
    isGooglePlayPayInfoPage: Boolean,
    payInfoLinkHtml: {
        type: String,
        required: false,
        default: ''
    }
});

// ボタンクリックでグループが増えるタイプの処理
function groupCountInclement(item) {
    if (item.currentLoopCount.value >= item.maxLoopCount) return;
    for(const index in props.items) {
        const targetItem = props.items[index];
        if (targetItem.groupKey !== item.groupKey) continue;
        targetItem.currentLoopCount.value++;
        break;
    }
}
function getInputModelKey(item, index, isLoop) {
    if (isLoop) {
        return item.name + index;
    }
    return item.name;

}
const isActiveButton = computed(() => {
    for(let i = 0; i < props.items.length; i++) {
        let item = props.items[i];
        if (item.required && !props.inputValues[getInputModelKey(item)]) {
            return false;
        }
    }
    return true;
});
const emit = defineEmits(['changeIndex', 'updateInputValue', 'resetInputValue'])
const index = inject('index');


function getPlaceHolder(item) {
    if ('placeHolder' in item) {
        return '例： ' + item.placeHolder;
    }
    return '';

}


</script>

<template>
    <div class="uk-margin-small-left uk-margin-small-right uk-flex-1">
        <div class="uk-flex uk-flex-column uk-height-1-1">
            <headline-component :title="props.title"/>
            <div id="guidance-wrapper" class="uk-flex-1 uk-margin uk-flex uk-flex-column uk-overflow-auto">
                <Guidance-component class="uk-width-1-1" :message="message"/>
                <a v-if="isGooglePlayPayInfoPage" class="uk-text-left uk-margin-small" target="_blank" href="https://support.google.com/googleplay/answer/2850369?hl=ja">注文履歴の確認方法はこちら</a>
                <div v-if="payInfoLinkHtml" v-html="payInfoLinkHtml"></div>
                <div v-if="image" class="uk-margin-top">
                    <img :src="image" alt="image" class="uk-width-1-1"/>
                </div>
                <div id="selection-area" class="uk-margin uk-text-center uk-flex-1">
                    <div class="uk-flex" :class="{'uk-flex-row': direction === 'row', 'uk-flex-column': direction !== 'row'}">
                        <div v-for="item in items" class="uk-width-1 uk-margin-right">
                            <template v-if="'groups' in item">
                                <div v-for="loopCount in item.currentLoopCount.value">
                                    <div v-for="groupItem in item.groups">
                                        <div class="uk-width-1 uk-margin-right uk-position-relative">
                                            <div class="uk-text-left uk-h5 uk-margin-remove-bottom">{{ groupItem.name }}
                                                <span v-if="groupItem.required" style="color: red; font-size: 0.8em;">(必須)</span>
                                                <span v-else>(任意)</span>
                                            </div>
                                            <div class="uk-text-left" v-if="groupItem.notice">{{ groupItem.notice }}</div>
                                            <template v-if="'selections' in groupItem">
                                                <select class="uk-select uk-margin-small-bottom"
                                                        v-model="inputValues[getInputModelKey(groupItem, loopCount, true)]">
                                                    <option v-for="selection in groupItem.selections"
                                                            :value="selection.text">{{ selection.text }}
                                                    </option>
                                                </select>
                                            </template>
                                            <template v-else>
                                                <input class="uk-input uk-margin-top uk-margin-bottom"
                                                       :placeholder="getPlaceHolder(groupItem)"
                                                       v-model="inputValues[getInputModelKey(groupItem, loopCount, true)]"/>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="item.currentLoopCount.value < item.maxLoopCount" class="uk-text-primary uk-link-text uk-position-relative"
                                     @click="groupCountInclement(item)"
                                     style="z-index: 2; cursor: pointer;">{{item.groupDescription}}</div>
                            </template>
                            <template v-else>
                                <div>
                                    <div class="uk-text-left uk-h5 uk-margin-remove-bottom">{{ item.name }}
                                        <span v-if="item.required" style="color: red; font-size: 0.8em;">(必須)</span>
                                        <span v-else>(任意)</span>
                                    </div>
                                    <div class="uk-text-left" v-if="item.notice">{{ item.notice }}</div>
                                    <div v-for="i in ('loopCount' in item) ? item.loopCount : 1" class="uk-position-relative" style="z-index: 2;">
                                        <template v-if="'selections' in item">
                                            <select class="uk-select uk-margin-small-bottom"
                                                    v-model="inputValues[getInputModelKey(item, i, ('loopCount' in item))]">
                                                <option v-for="selection in item.selections" :value="selection.text">
                                                    {{ selection.text }}
                                                </option>
                                            </select>
                                        </template>
                                        <template v-else>
                                            <input class="uk-input uk-margin-top uk-margin-bottom"
                                                   :placeholder="getPlaceHolder(item)"
                                                   v-model="inputValues[getInputModelKey(item, i, ('loopCount' in item))]"/>
                                        </template>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <page-transition
                @change-index="(index,key,value) => {$emit('changeIndex',index,key,value);}"
                @reset-input-value="(index) => {$emit('resetInputValue', index);}"
                :index="index"
                :previous-index="previousIndex"
                :next-index="nextIndex"
                :isActiveButton="isActiveButton"
                :selections="null"
            ></page-transition>
        </div>
    </div>
</template>

<style scoped>
#selection-area {
    align-items: center;
}
</style>